import type { CSSProperties } from 'react';
import type { WorkPriority } from '@captain-tasko/shared';

const STYLES: Record<WorkPriority, { bg: string; fg: string; label: string }> = {
  critical: { bg: '#B3261E', fg: '#FFFFFF', label: 'Critical' },
  high:     { bg: '#A56B00', fg: '#FFFFFF', label: 'High' },
  medium:   { bg: '#2A5C8C', fg: '#FFFFFF', label: 'Medium' },
  low:      { bg: '#D5D2CB', fg: '#5C5A52', label: 'Low' },
};

export function PriorityPill({
  priority,
  size = 'sm',
  onClick,
}: {
  priority: WorkPriority;
  size?: 'sm' | 'md';
  /**
   * When provided, the pill renders as a clickable <button> with the
   * same look. Used by WorkItemsList to let row pills narrow the list
   * to that priority. stopPropagation keeps the row click from firing.
   */
  onClick?: (priority: WorkPriority) => void;
}) {
  const s = STYLES[priority] ?? STYLES.medium;
  const padding = size === 'md' ? '4px 10px' : '2px 8px';
  const fontSize = size === 'md' ? 12 : 11;
  const style: CSSProperties = {
    background: s.bg,
    color: s.fg,
    padding,
    borderRadius: 999,
    fontSize,
    fontWeight: 600,
    letterSpacing: '.02em',
    textTransform: 'uppercase',
    display: 'inline-block',
    lineHeight: 1.2,
  };

  if (onClick) {
    return (
      <button
        type="button"
        title={`Filter by priority: ${s.label}`}
        onClick={(e) => { e.stopPropagation(); onClick(priority); }}
        style={{ ...style, border: 'none', cursor: 'pointer', font: 'inherit' }}
      >
        {s.label}
      </button>
    );
  }

  return <span style={style}>{s.label}</span>;
}
